module.exports = __webpack_public_path__ + "static/media/yoda.6d3b9a29.png";